function LibraryTitle() {
    return (
        <div>
            <h1 className="hero-text">Books & Notes</h1>
            <h1 className="hero-text">Library</h1>
            <h5 className="hero-text">by Reymond Mesuga</h5>
        </div>
    )
}
export default LibraryTitle;